import Cookies from 'js-cookie';
import { getLocaleInfo } from '@/utils/helpers';
import { ROUTES } from '@/app/[locale]/constants';

export type redirectToPlayGeniusCheckoutProps = {
  invoiceId: string;
  localeInfo: ReturnType<typeof getLocaleInfo>;
  isRecurringPuf: boolean;
  source: string;
  discountCode?: string;
};

export async function redirectToPlayGeniusCheckout({
  invoiceId,
  localeInfo,
  discountCode,
  isRecurringPuf,
  source,
}: redirectToPlayGeniusCheckoutProps) {
  const loveveryId = localStorage.getItem('lovevery_id');

  // Cleanup Subflow State
  Cookies.remove('referral_code');
  window.localStorage.removeItem('subflow-v3-referral-code');

  // Construct Checkout Rewrite URL
  const baseUrl = new URL(
    `/${localeInfo.locale}${ROUTES.CHECKOUT_CUSTOMER_INFORMATION}/${invoiceId}`,
    window.location.origin,
  );

  // Set the common search parameters
  baseUrl.searchParams.set('language', localeInfo.language);
  baseUrl.searchParams.set('currency', localeInfo.currencyCode.toLowerCase());
  baseUrl.searchParams.set('epb', 'val');
  baseUrl.searchParams.set('esc', 'val');
  baseUrl.searchParams.set('referrer', source);

  // Set optional parameters
  if (discountCode) {
    baseUrl.searchParams.set('referral_code', discountCode);
  }

  if (loveveryId) {
    baseUrl.searchParams.set('lovevery_id', loveveryId);
  }

  if (isRecurringPuf) {
    baseUrl.searchParams.set('has_opted_in_to_recurring_puf', 'false');
  }

  // Redirect to the constructed URL
  window.location.href = baseUrl.toString();
}
